module.exports = __webpack_public_path__ + "img/chat-bg.8c5d5709.png";